import { inject, Injectable } from '@angular/core';
import { UtmStorageService } from '../utm-storage/utm-storage.service';

const validUtmParams = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

@Injectable({
  providedIn: 'root',
})
export class UtmService {
  private utmStorageService = inject(UtmStorageService);

  setUtmParamsToUrl(url: string) {
    const utmParams = this.utmStorageService.get() || {};
    const sckParams = this.createSCKParam(utmParams);

    const urlParams = {
      ...sckParams,
      ...utmParams,
    };

    return this.createUrl(url, urlParams);
  }

  createSCKParam(utmParams: Record<string, string>): { sck?: string } {
    const utmParamsArray = [
      utmParams.utm_source,
      utmParams.utm_medium,
      utmParams.utm_campaign,
      utmParams.utm_term,
      utmParams.utm_content,
    ];

    const sckParamValue = utmParamsArray.map((param) => param || '').join('|');

    if (!sckParamValue) {
      return {};
    }

    return {
      sck: sckParamValue,
    };
  }

  createUrl(url: string, urlParams: Record<string, string>): string {
    const urlInstance = new URL(url);

    for (const key in urlParams) {
      urlInstance.searchParams.set(key, urlParams[key]);
    }

    return urlInstance.toString();
  }

  getUtmQueryParamsFromUrl(): Record<string, string> {
    const url = new URL(window.location.href);

    const [_, queryParams] = url.search.split('?');

    if (!queryParams) {
      return {} as Record<string, string>;
    }

    const keyValueArray = queryParams.split('&');

    const queryParamsObject = keyValueArray.reduce(
      (acc, keyValue) => {
        const [key, value] = keyValue.split('=');

        if (!key || !value) {
          return acc;
        }

        if (validUtmParams.includes(key)) {
          acc[key] = value;
        }

        return acc;
      },
      {} as Record<string, string>,
    );

    return queryParamsObject;
  }
}
